import React from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color, formStyles, breakpoints } from '../../utils/style';
import { Formik, Field, Form } from 'formik';
import IcomoonIcon from '../shared/IcomoonIcon';
import withLocation from '../shared/withLocation';

const SearchWrap =  styled('div')`
   ${formStyles}
   .search-form {
     margin-top: 2px;
     max-width: 200px;
     margin: 0 auto;
     position: relative;
     input {
       border-color: ${color.gold};
     }
     .error-new + input {
       border-color: ${color.red};
     }
     .fieldWrap {
       width: 100%;
       .error {
         right: auto;
         top: 1px;
         left: 50px;
         background: none;
         font-size: 11px;
       }
       label {
         font-size: 0;
         color: transparent;
         padding: 0;
       }
     }
     .button {
       padding: 10px 12px;
       margin: 0 0 0 10px;
       position: absolute;
       top: 3px;
       right: 3px;
       height: 40px;
       background: transparent;
       border-color: transparent;
       &:hover, &:active {
         background: ${color.gold};
         svg {
          path {fill: ${color.trueBlack} !important;}
         }
       }
       &:disabled {
         background: transparent;
         border-color: transparent;
       }
     }
   }
   @media (max-width: ${breakpoints.md}) {
     padding: 15px;
     height: 75px;
     width: 100%;
     .search-form {
       width: calc(100% - 85px);
       float: left;
     }
   }
   @media (max-width: ${breakpoints.sm}) {
     .search-form {
       margin-top: 0;
       .fieldWrap {
         padding-bottom: 3px;
       }
     }
   }
`;

const FormBody = ({ search }) => {
  let query = search;
  let  searchtext = '';
  if (query && query.q) {
    searchtext = query.q;
  }

  const initialValues = {
    q: searchtext,
  };

  const onSubmit = values => {
    const path = '/search/?q=' + values.q;
    navigate(path);
  };

  /*const onBlur = (e) => {
   const searchValue = e.target.value;
   if (query.q && (searchValue !== query.q)) {
     const path = '/search/?q=' + searchValue;
     mobileCloseFunction();
     navigate(path);
   }
  };*/

  const validateSearch = (values) => {
    let errors = {};
    let searchtext = values.q + '';
    if(searchtext.length < 3){
      errors.q = 'Minimum 3 characters';
    }
    return errors;
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validateSearch}>
      {({ errors, touched, isSubmitting, isValid, values }) => (
        <Form id="searchForm" className="search-form">
          <div className="fieldWrap">
            <label htmlFor="search-query">Search</label>
            {errors.q && touched.q && <div className="error-new">! {errors.q}</div>}
            <Field type="text" name="q" placeholder="Search" id="search-query"
                   value={values.q || ''} />
          </div>
          <button aria-label="Search" className="button" type="submit" disabled={(isSubmitting || !isValid)}>
            <IcomoonIcon icon="search-2" color={color.white} size={18} />
          </button>
        </Form>
      )}
    </Formik>
  );
};

const SearchForm = ({ search, handlerFunction }) => {
  return(
    <SearchWrap>
      <FormBody search={search} mobileCloseFunction={handlerFunction}/>
    </SearchWrap>
  )
};

export default withLocation(SearchForm);

SearchForm.propTypes = {
  search: PropTypes.object,
  handlerFunction: PropTypes.func,
};
